// extracted by mini-css-extract-plugin
export default {"root":"styles_root__OZo1U","initials":"styles_initials__25t-H","image":"styles_image__I5nas"};